import React from 'react';

const SurveillanceCameras = () => {
  return (
    <div style={{ padding: 16 }}>
      <h2 style={{ marginBottom: 8 }}>Surveillance Cameras</h2>
      <div style={{ color: '#64748b' }}>Coming soon</div>
    </div>
  );
};

export default SurveillanceCameras;
